import { render, staticRenderFns } from "./akcd_overview_lst.vue?vue&type=template&id=3f10ff32&scoped=true"
import script from "./akcd_overview_lst.vue?vue&type=script&lang=js"
export * from "./akcd_overview_lst.vue?vue&type=script&lang=js"
import style0 from "./akcd_overview_lst.vue?vue&type=style&index=0&id=3f10ff32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f10ff32",
  null
  
)

export default component.exports